import React from 'react';
import { Chip } from '@material-ui/core';
import { Container } from './styles';

interface IFiltro {
  com_erro: boolean;
  sem_erro: boolean;
}

interface IEtapa {
  filtro: IFiltro;
  setFiltro: (filtro: IFiltro) => void;
}

const FiltroHorizontalCheckStatus: React.FC<IEtapa> = ({
  filtro,
  setFiltro,
}) => {
  return (
    <>
      <Container>
        <h2>Status:</h2>
        <Chip
          variant="default"
          color="default"
          style={{
            textDecoration: filtro.com_erro ? 'none' : 'line-through',
          }}
          size="small"
          onClick={() => setFiltro({ ...filtro, com_erro: !filtro.com_erro })}
          label="Com erro/ sincronizando"
        />
        <Chip
          variant="default"
          color="default"
          size="small"
          style={{
            textDecoration: filtro.sem_erro ? 'none' : 'line-through',
          }}
          onClick={() => setFiltro({ ...filtro, sem_erro: !filtro.sem_erro })}
          label="Sem erro/ sincronizando"
        />
      </Container>
    </>
  );
};

export default FiltroHorizontalCheckStatus;
